@if (data) {
    <article class="container">
        <div class="row"
             [ngClass]="[data.alignment === alignment.Left ? 'left' : '']"
        >
            <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                @if (data.image && data.image.src) {
                    <div class="image-wrapper">
                        <app-image
                            [image]="data.image"
                            [index]="data.spotIndex"
                            [width]="712"
                            [height]="520"
                            [style]="{
                                objectFit: 'cover',
                                objectPosition: data.image.focalPoint | imageFocalPoint : data.alignment,
                                height: '100%'
                            }"
                            [intersectionOptions]="{ threshold: 0 }"
                            crop="min"
                        ></app-image>
                    </div>
                }
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-6"
                 [style.background-color]="data.backgroundColor | stringToColor">
                <div class="content-wrapper">
                    <div class="content" [ngClass]="{ white: data.textColor === textColor.White }">
                        @if (data.teaserText) {
                            <span class="teaser display-3 handwriting">{{ data.teaserText }}</span>
                        } @if (data.headlineText) {
                        <app-spot-headline [index]="data.spotIndex" section="h1">
                            {{ data.headlineText }}
                        </app-spot-headline>
                    } @if (data.richText) {
                        <div
                            class="kk-rte text"
                            appInterceptLinks
                            [innerHTML]="data.richText | safe: 'html'"
                        ></div>
                    } @if (data.link; as link) {
                        <a class="kk-btn kk-btn_secondary link"
                           [href]="link.url"
                           [target]="link.target || '_self'"
                        >{{ link.name }}</a>
                    }
                    </div>
                </div>
            </div>
        </div>
    </article>
}
